import type { HealthState } from "contracts/enums/core";
import { healthVar } from "./health";

type ThresholdBarProps = {
  score: number | null;
  good: number;
  watch: number;
  target: number | null;
  state: HealthState;
  height?: number;
};

export function ThresholdBar(props: ThresholdBarProps) {
  const height = () => `${props.height ?? 6}px`;
  const fillWidth = () =>
    `${props.score === null ? 0 : Math.max(0, Math.min(100, props.score))}%`;

  return (
    <div class="thr" style={{ height: height() }}>
      <div class="thr-zones">
        <div
          class="thr-zone"
          style={{ width: `${props.watch}%`, background: "var(--poor-soft)" }}
        />
        <div
          class="thr-zone"
          style={{
            width: `${props.good - props.watch}%`,
            background: "var(--watch-soft)",
          }}
        />
        <div
          class="thr-zone"
          style={{
            width: `${100 - props.good}%`,
            background: "var(--good-soft)",
          }}
        />
      </div>
      <div
        class="thr-fill"
        style={{ width: fillWidth(), background: healthVar(props.state) }}
      />
      {props.target !== null ? (
        <div class="thr-target" style={{ left: `${props.target}%` }} />
      ) : null}
    </div>
  );
}
